/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Stat_MissInputs */

const bn_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মিস`)
};

const de_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vermissen`)
};

const el_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεσποινίδα`)
};

const en_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miss`)
};

const es_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extrañar`)
};

const fr_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ratés`)
};

const hi_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`याद`)
};

const hu_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiányzik`)
};

const id_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merindukan`)
};

const it_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mancare`)
};

const ja_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`逃す`)
};

const ko_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`놓치다`)
};

const nl_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missen`)
};

const pl_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chybić`)
};

const pt_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perder`)
};

const ru_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скучать`)
};

const sv_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miss`)
};

const tr_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kayıp`)
};

const uk_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Міс`)
};

const vi_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cô`)
};

const zh_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`错过`)
};

const zh_hant_game_stat_miss = /** @type {(inputs: Game_Stat_MissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`錯過`)
};

/**
* | output |
* | --- |
* | "Miss" |
*
* @param {Game_Stat_MissInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_stat_miss = /** @type {((inputs?: Game_Stat_MissInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Stat_MissInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_stat_miss(inputs)
	if (locale === "de") return de_game_stat_miss(inputs)
	if (locale === "el") return el_game_stat_miss(inputs)
	if (locale === "en") return en_game_stat_miss(inputs)
	if (locale === "es") return es_game_stat_miss(inputs)
	if (locale === "fr") return fr_game_stat_miss(inputs)
	if (locale === "hi") return hi_game_stat_miss(inputs)
	if (locale === "hu") return hu_game_stat_miss(inputs)
	if (locale === "id") return id_game_stat_miss(inputs)
	if (locale === "it") return it_game_stat_miss(inputs)
	if (locale === "ja") return ja_game_stat_miss(inputs)
	if (locale === "ko") return ko_game_stat_miss(inputs)
	if (locale === "nl") return nl_game_stat_miss(inputs)
	if (locale === "pl") return pl_game_stat_miss(inputs)
	if (locale === "pt") return pt_game_stat_miss(inputs)
	if (locale === "ru") return ru_game_stat_miss(inputs)
	if (locale === "sv") return sv_game_stat_miss(inputs)
	if (locale === "tr") return tr_game_stat_miss(inputs)
	if (locale === "uk") return uk_game_stat_miss(inputs)
	if (locale === "vi") return vi_game_stat_miss(inputs)
	if (locale === "zh") return zh_game_stat_miss(inputs)
	return zh_hant_game_stat_miss(inputs)
});